export { default } from './TrendTopicDetail';
